import { DisplayControlGroup } from 'features/DisplayControlGroup/models';
import { DisplayTimingGroupDetail } from 'features/MenuList/models/menu';
import { Overlay } from 'features/OverlayFunction/models/overlay';
import { CommonResponse } from 'models';
import axiosClient from 'utils/axiosClient';

const services = {
  getOverlayGroups(): Promise<CommonResponse<Overlay[]>> {
    const url = '/overlays';
    return axiosClient.get(url);
  },

  getDisplayControlGroups(): Promise<CommonResponse<DisplayControlGroup[]>> {
    const url = 'control-group-menu/list/';
    return axiosClient.get(url);
  },
  getMenuOrderQuantityLimitView(): Promise<CommonResponse<DisplayControlGroup[]>> {
    const url = 'menu-order-quantity-limit';
    return axiosClient.get(url);
  },
  getListOrderQuantityLimit(): Promise<CommonResponse<{ key: string; value: string }[]>> {
    const url = '/orders-limit';
    return axiosClient.get(url);
  },
  getMenuServiceTime(): Promise<CommonResponse<{ id: number; name: string }[]>> {
    const url = '/menu-service-time';
    return axiosClient.get(url);
  },
  getMenuWizard(): Promise<CommonResponse<{ id: number; name: string }[]>> {
    const url = '/menu-wizard';
    return axiosClient.get(url);
  },
  getDisplayTimingGroups(): Promise<CommonResponse<DisplayTimingGroupDetail[]>> {
    const url = '/menu-display-timing-groups';
    return axiosClient.get(url);
  },
};

export default services;
